import * as React from 'react';
import {
  IconInfrastructureChildPlayground16,
  IconInfrastructureCommercialObject16,
  IconInfrastructurePet16,
  IconInfrastructureFastService16,
  IconInfrastructureFitness16,
  IconInfrastructureKid16,
  IconInfrastructureOffice16,
  IconInfrastructureHospital16,
  IconInfrastructurePool16,
  IconInfrastructureRestaurant16,
  IconInfrastructureSchool16,
  IconInfrastructureSpa16,
  IconInfrastructureSportsground16,
  IconInfrastructureSupermarket16,
  IconInfrastructureParking16,
  IconSafetyBarrier16,
  IconSafetySecurity16,
  IconSafetyOutdoorCamera16,
  IconComfortReception16,
  IconSafetyFireExtinguisher16,
  IconSafetySecurityParking16,
  IconSafetyCloseArea16,
  IconSafetySignal16,
} from '@cian/ui-kit-design-tokens/icons';
import { EShortInfraType, EParkingType, ESecutiryType } from '../types/newbuilding/specificationsDetailed';

export const DETAILED_SPECIFICATIONS_ICON_MAP: { [id: string]: React.ReactNode } = {
  [EShortInfraType.Children]: <IconInfrastructureChildPlayground16 />,
  [EShortInfraType.Commerce]: <IconInfrastructureCommercialObject16 />,
  [EShortInfraType.Dogs]: <IconInfrastructurePet16 />,
  [EShortInfraType.Domestic]: <IconInfrastructureFastService16 />,
  [EShortInfraType.Fitness]: <IconInfrastructureFitness16 />,
  [EShortInfraType.Kindergarten]: <IconInfrastructureKid16 />,
  [EShortInfraType.Offices]: <IconInfrastructureOffice16 />,
  [EShortInfraType.Polyclinic]: <IconInfrastructureHospital16 />,
  [EShortInfraType.Pool]: <IconInfrastructurePool16 />,
  [EShortInfraType.Recreation]: <IconInfrastructureChildPlayground16 />, //
  [EShortInfraType.Restaurant]: <IconInfrastructureRestaurant16 />,
  [EShortInfraType.School]: <IconInfrastructureSchool16 />,
  [EShortInfraType.Spa]: <IconInfrastructureSpa16 />,
  [EShortInfraType.Sport]: <IconInfrastructureSportsground16 />,
  [EShortInfraType.Supermarket]: <IconInfrastructureSupermarket16 />,
  [EParkingType.Guest]: <IconInfrastructureParking16 />,
  [EParkingType.Standalone]: <IconInfrastructureParking16 />,
  [EParkingType.Underground]: <IconInfrastructureParking16 />,
  [ESecutiryType.Access]: <IconSafetyBarrier16 />,
  [ESecutiryType.AroundTheClock]: <IconSafetySecurity16 />,
  [ESecutiryType.Camera]: <IconSafetyOutdoorCamera16 />,
  [ESecutiryType.Concierge]: <IconComfortReception16 />,
  [ESecutiryType.Fire]: <IconSafetyFireExtinguisher16 />,
  [ESecutiryType.Parking]: <IconSafetySecurityParking16 />,
  [ESecutiryType.Perimetr]: <IconSafetyCloseArea16 />,
  [ESecutiryType.Signal]: <IconSafetySignal16 />,
};
